module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-craft-32.54b26c17.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-craft-32.png
// module id = 3193
// module chunks = 11